export enum AttachmentFilter {
  ORDER = 'medicalOrders',
  PRESCRIPTION = 'prescriptions',
  CONSTANCY = 'medicalCareRecord',
  NO_ATTACHMENT = 'noAttachment',
}
